/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uMenu.vue?vue&type=template&id=7a0af4ce&scoped=true"
import script from "./uMenu.vue?vue&type=script&lang=js"
export * from "./uMenu.vue?vue&type=script&lang=js"
import style0 from "./uMenu.vue?vue&type=style&index=0&id=7a0af4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0af4ce",
  null
  
)

export default component.exports